<template>
  <div>
  <card class="card">
    <div class="card-body">
      <h2 class="pt-0 mt-0">
        <i class="fas fa-user-cog text-primary"></i> {{$t('user.titleedit')}}
      </h2>
      <hr>
      <div>
        <form @submit.prevent id="userEdit">
          <div class="row">
            <div class="col-md-12">
              <fg-input type="text" :label="$t('user.name')" name="name" :placeholder="$t('user.name')" v-model="form.name"></fg-input>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <fg-input
                type="email"
                :label="$t('user.email')"
                name="email"
                :placeholder="$t('user.email')"
                v-model="form.email"
              ></fg-input>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label class="typo__label">{{$t('user.asf')}}</label>
              <multiselect
                v-model="value"
                :options="asfs"
                :custom-label="asfLabel"
                :placeholder="$t('user.text.selectone')"
                label="name"
                track-by="id"
              ></multiselect>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label for="role">{{$t('user.role')}}</label>
              <div class="form-check">
                <input
                  type="checkbox"
                  class="form-check-input"
                  name="roles[]"
                  v-model="form.role"
                  value="admin"
                  id="admin"
                  :checked="checked('admin')"
                >
                <label for="admin">{{$t('user.admin')}}</label>
              </div>
              <div class="form-check">
                <input
                  type="checkbox"
                  class="form-check-input"
                  name="roles[]"
                  v-model="form.role"
                  value="asf-admin"
                  id="asf-admin"
                  :checked="checked('asf-admin')"
                >
                <label for="asf-admin">{{$t('user.asfadmin')}}</label>
              </div>
              <div class="form-check">
                <input
                  type="checkbox"
                  class="form-check-input"
                  name="roles[]"
                  v-model="form.role"
                  value="asf-frontdesk"
                  id="asf-frontdesk"
                  :checked="checked('asf-frontdesk')"
                >
                <label for="asf-frontdesk">{{$t('user.asffrontdesk')}}</label>
              </div>
              <div class="form-check">
                <input
                  type="checkbox"
                  class="form-check-input"
                  name="roles[]"
                  v-model="form.role"
                  value="asf-technician"
                  id="asf-technician"
                  :checked="checked('asf-technician')"
                >
                <label for="asf-technician">{{$t('user.asftechnician')}}</label>
              </div>
              <div class="form-check">
                <input
                  type="checkbox"
                  name="roles[]"
                  class="form-check-input"
                  v-model="form.role"
                  value="client"
                  id="client"
                  :checked="checked('client')"
                >
                <label for="client">Client</label>
              </div>
            </div>
          </div>

          <div class="text-left">
            <p-button type="primary" @click.native.prevent="updateProfile">{{$t('user.button.updateprofile')}}</p-button>
          </div>
          <div class="clearfix"></div>
        </form>
      </div>
    </div>
  </card>

  <card class="card">
    <div class="card-body">
      <div>
        <h3>{{$t('user.button.resetpassword')}}</h3>
        <form @submit.prevent id="userResetPass" class="d-flex align-items-center justify-content-between align-items-center">
          <div class="d-flex align-items-center flex-grow-1 mr-2">
            <input type="text" class="form-control" v-model="newPassword" disabled :placeholder="$t('user.newpassword')" />
            <button type="button" class="btn btn-primary ml-2 d-flex align-items-center" @click="copyPassword">
              <i class="fas fa-copy"></i>
            </button>
          </div>
          <p-button type="primary" class="btn-sm d-flex align-items-center" @click.native.prevent="resetPassword">{{$t('user.button.resetpassword')}}</p-button>
        </form>
      </div>
    </div>
  </card>

</div>
</template>
<script>
import { mapState } from "vuex";
import Multiselect from "vue-multiselect";
export default {
  components: {
    Multiselect
  },
  data() {
    return {
      value: {},
      form: {},
      newPassword: ''
    };
  },
  computed: {
    ...mapState("users", {
      user: "user"
    }),
    ...mapState("asfs", {
      asfs: "all"
    })
  },
  created() {
    this.$store.dispatch("users/getUser", this.$route.params.id);
    this.$store.dispatch("asfs/getAllAsfs");
  },
  watch: {
    user: function(newData) {
      this.value = newData.asf;
      this.form.id = newData.id;
      this.form.name = newData.name;
      this.form.email = newData.email;
      this.form.role = newData.role;
      this.form.asf = newData.asf[0] ? newData.asf[0].id : null;
    },
    value: function(newData) {
      if (newData instanceof Object) {
        this.form.asf = newData.id;
      }
    }
  },
  methods: {
    asfLabel({ name, vat }) {
      return `${name} — ${vat}`;
    },
    updateProfile() {
      // let form = document.getElementById("userEdit");
      // let data = new FormData(form);
      // console.log(JSON.stringify(data));
      // console.log(formElements);
      this.$store
        .dispatch("users/editUser", this.form)
        .then(response => {
          this.$router.push({ name: "users" });
          this.$notify({
            type: "success",
            message: this.$t('user.message.successupdate')
          });
        })
        .catch(error => {
          this.$router.push({ name: "users" });
          this.$notify({
            type: "danger",
            message: "Error! The user data could not be updated."
          });
        });
    },
    async resetPassword() {
      try {
        const response = await this.$store.dispatch("users/resetPass", this.form.id);
        this.newPassword = response.data.new_pass;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: "Error! The user data could not be updated."
        });
      }
    },
    copyPassword() {
      navigator.clipboard.writeText(this.newPassword);
      this.$notify({ type: 'success', message: this.$t('user.message.copied') });
    },
    checked(value) {
      if (!this.form.role) {
        return false;
      }
      return this.form.role.includes(value);
    }
  }
};
</script>
<style>
</style>
